import { Injectable, Inject } from '@angular/core';
import {
    NavController, LoadingController, Loading, ToastController,
    AlertController, PopoverController
} from 'ionic-angular';

import { CustomerModel } from '../models/customer/customer.model';
import { OrderHeaderModel } from '../models/order/orderheader.model';

import { ErrorLogService } from './errorlog.service';
import { APP_CONFIG, IAppConfig } from '../config/app-config';
import { StorageService } from './storage.service';
import { SettingId } from '../enums/settingid.enum';
import { UrgentOrderTimeSlotEnum } from '../enums/urgentordertimeslot.enum';

@Injectable()
export class UtilService {
     filterByType: any='';

    constructor(@Inject(APP_CONFIG) private config: IAppConfig,
        private errorLogService: ErrorLogService, private storageService: StorageService) {
    }

    getWebServiceURL() {
            return this.config.URL;
    }
    getGMapGeoURL() {
        return this.config.GMapGeoURL;
    }

    displayAlert(alertCtrl: AlertController, title: string, message: string) {
        alertCtrl.create({
            title: title,
            subTitle: message,
            buttons: ['OK']
        }).present();
    }
    displayAlertWithRedirectPage(alertCtrl: AlertController, navCtrl: NavController, title: string, message: string, pageIndex: any) {
        alertCtrl.create({
            title: title,
            subTitle: message,
            enableBackdropDismiss: false,
            buttons: [{
                text: 'OK',
                role: 'ok',
                handler: () => {
                    navCtrl.parent.select(pageIndex);
                    return true;
                }
            }]
        }).present();
    }
    displayLoading(loading: Loading, loadingCtrl: LoadingController, message: string) {
        loading = loadingCtrl.create({
            spinner: 'hide',
            cssClass: 'progress-loading',
            content: `
                <div class="progress-content">
                    <div class="progress-title">${message}...</div>
                    <div class="progress-subtitle">Please wait while we process your request</div>
                    <div class="progress-bar-container">
                        <div class="progress-bar-fill"></div>
                    </div>
                    <div class="progress-footer">
                        <span class="progress-label">Progress</span>
                        <span class="progress-percentage"></span>
                    </div>
                </div>
            `,
            enableBackdropDismiss: false
        });

        const originalDismiss = loading.dismiss.bind(loading);
        loading.dismiss = (data?: any, role?: string, navOptions?: any): Promise<any> => {
            try {
                const wrapper = document.querySelector('.progress-loading');
                if (wrapper) {
                    const fill = wrapper.querySelector('.progress-bar-fill') as HTMLElement;
                    const pct = wrapper.querySelector('.progress-percentage') as HTMLElement;
                    if (fill) {
                        fill.style.animation = 'none';
                        fill.style.transition = 'width 0.4s ease-out';
                        fill.style.width = '100%';
                    }
                    if (pct) {
                        pct.style.animation = 'none';
                        pct.classList.add('complete');
                        pct.innerHTML = '100%';
                    }
                }
            } catch (e) {}
            return new Promise(resolve => {
                setTimeout(() => {
                    originalDismiss(data, role, navOptions).then(resolve).catch(resolve);
                }, 500);
            });
        };

        loading.present();
        return loading;
    }
    displayPopover(popoverCtrl: PopoverController, componentName: any, event: any) {
        popoverCtrl.create(componentName).present({ ev: event });
    }
    processError(loading: Loading, alertCtrl: AlertController, err: any) {
        loading.dismiss();
        let errObj = this.errorLogService.generateErrorMsg(err);

        //Token related
        // static TokenEmpty = new AppError("TokenEmpty", "Your access token is empty. Please re-login!");
        // static TokenInvalid = new AppError("TokenInvalid", "Your access token is invalid. Please re-login!");
        // static TokenExpired = new AppError("TokenExpired", "Your access token has expired. Please re-login!");
        // if (errObj.Code == "TokenEmpty" || errObj.Code == "TokenInvalid" || errObj.Code == "TokenExpired") {
        //     this.displayAlertWithRedirectPage(alertCtrl, navCtrl, errObj.Title, errObj.Message,)
        // } else {
        //     this.displayAlert(alertCtrl, errObj.Title, errObj.Message);
        // }
        this.displayAlert(alertCtrl, errObj.Title, errObj.Message);
    }
    displayToast(toastCtrl: ToastController, title: string) {
        toastCtrl.create({
            message: title,
            duration: 2000,
            position: 'top',
            cssClass: 'margin-top-20'
            // showCloseButton: true,
            // closeButtonText: 'OK'
        }).present();
    }
    changeTab(loading: Loading, loadingCtrl: LoadingController, navCtrl: NavController, index: number) {
        loading = this.displayLoading(loading, loadingCtrl, "transitioning");
        navCtrl.parent.select(index);
        loading.dismiss();
    }
    displayConfirmation(alertCtrl: AlertController, title: string, message: string, arrButtons: any[]) {
        alertCtrl.create({
            title: title,
            subTitle: message,
            buttons: arrButtons
        }).present();
    }

    createNewOrder(customer: CustomerModel, salesrepCode: string, orderType: string) {
        let o = new OrderHeaderModel();
        o.currency = this.storageService.getCurrency();
        o.salesrep_code = salesrepCode;
        o.ord_type = orderType;
        o.sales_ind = this.storageService.getSalesInd();
        o.shipto_code = customer.salesorg.shipto_list[0].code;
        o.soldto_code = customer.cust_code;
        o.soldto_name = customer.cust_name;
        o.salesorg = customer.salesorg.salesorg;
        o.distchannel = customer.salesorg.distchannel;
        o.division = customer.salesorg.division;
        o.pay_term_code = customer.pay_term_code;
        o.pay_term_name = customer.pay_term_name;
        o.payer_code = customer.payer.payer_code;
        o.affiliate_order = customer.payer.affiliate_payer;
        o.order_reason = customer.order_reason;
        if (customer.salesorg.partial_dlvy_flag == 'X') {
            o.partial_delivery = 'Y';
        }
        o.detail = [];

        return o;
    }

    isSameCustomer(customer1: CustomerModel, customer2: CustomerModel) {
        if (!customer1 || !customer2) {
            return false;
        }

        const salesOrg1 = customer1.salesorg;
        const salesOrg2 = customer2.salesorg;

        if (!salesOrg1 || !salesOrg2) {
            return false;
        }

        const shipTo1 = salesOrg1.shipto_list?.[0]?.code;
        const shipTo2 = salesOrg2.shipto_list?.[0]?.code;

        if (!shipTo1 || !shipTo2) {
            return false;
        }

        const payer1 = customer1.payer?.payer_code;
        const payer2 = customer2.payer?.payer_code;

        if (!payer1 || !payer2) {
            return false;
        }

       return customer1.cust_code === customer2.cust_code
                && salesOrg1.salesorg === salesOrg2.salesorg
                && salesOrg1.distchannel === salesOrg2.distchannel
                && salesOrg1.division === salesOrg2.division
                && shipTo1 === shipTo2
                && payer1 === payer2;
    }

    // getSalesIndFromOrder(order: OrderHeaderModel) {
    //     return (order.ord_type == 'ZORM' ? 'S' : 'F');
    // }

    //TODO: srsly?
    compareSalesrep(salesrepCode1: string, salesrepCode2: string) {
        if (salesrepCode1 == salesrepCode2) {
            return false;
        }
        return true;
    }
    checkTxnStatus(txnstatus) {
        if (txnstatus == 'S' || txnstatus == 'P' || txnstatus == 'E' || txnstatus == 'P' || txnstatus == 'C') {
            return false;
        }
        return true;
    }

    convertUTCDateToLocalDate(date) {
        if (date !== '') {
            let nd = new Date(date);
            if (nd.toString() === 'Invalid Date') {
                return date;
            }
            var y = nd.getFullYear();
            var m = nd.getMonth() + 1;
            var d = nd.getDate();
            var h = nd.getHours();
            var mi = nd.getMinutes();
            var s = nd.getSeconds();
            return (d < 10 ? ('0' + d) : d) + '-' + (m < 10 ? ('0' + m) : m) + '-' + y + ' ' + (h < 10 ? ('0' + h) : h) + ':' + (mi < 10 ? ('0' + mi) : mi) + ':' + (s < 10 ? ('0' + s) : s) + ' ' + ((h >= 12) ? "PM" : "AM");
        }
        else {
            return '';
        }
    }

    convertUTCDateToLocalDateOnly(date) {
        if (date !== '') {
            let nd = new Date(date);
            if (nd.toString() === 'Invalid Date') {
                return date;
            }
            var y = nd.getFullYear();
            var m = nd.getMonth() + 1;
            var d = nd.getDate();
            return (d < 10 ? ('0' + d) : d) + '-' + (m < 10 ? ('0' + m) : m) + '-' + y;
        }
        else {
            return '';
        }
    }

    convertUTCDateToLocalDateWithoutTime(date) {
        if (!date) return '';
        let nd = new Date(date);
        if (isNaN(nd.getTime())) {
            return date;
        }

        const dateOptions = { day: '2-digit', month: 'short', year: 'numeric' };
        const datePart = nd.toLocaleDateString('en-GB', dateOptions).replace(/,/g, '');

        const ampm = nd.getHours() >= 12 ? 'PM' : 'AM';

        return `${datePart} ${ampm}`;
    }

    checkEmailFormat(email) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)) {
            return (true);
        }
        return (false);
    }

    isAndroid(): boolean {
        return /Android/i.test(navigator.userAgent);
      }
      
      isIOS(): boolean {
        return /iPhone|Ipad|iPod/i.test(navigator.userAgent);
      }

    checkHideFooter(dataLength: number, direction: string = '') {
        if (this.isRemoveDKSHLogoForVN()) {
           let tabbar = document.getElementsByClassName('tabbar')[0];
           let topCaculatedOffset = tabbar.clientHeight * 2 + 10;
           document.documentElement.style.setProperty('--top-offset', topCaculatedOffset + 'px');
           document.documentElement.style.setProperty('--screen-height', window.innerHeight + 'px');
           return 0; 
        }       

        const footer = document.getElementById('eo-footer-in') as HTMLElement;
        const mainContent = document.querySelector('.main-content');

        if (!this.isAndroid() && !this.isIOS()) {
            footer.classList.remove('invisible');

            let tabbar = document.getElementsByClassName('tabbar')[0];
            let topCaculatedOffset = tabbar.clientHeight * 2 + 10;
            document.documentElement.style.setProperty('--top-offset', topCaculatedOffset + 'px');
            let bottomCaculatedOffset = document.getElementById('eo-footer-in').offsetHeight;
            document.documentElement.style.setProperty('--bottom-offset', bottomCaculatedOffset + 'px');
        
            let screenHeight = (window.innerHeight - bottomCaculatedOffset - topCaculatedOffset) + 'px';
            document.documentElement.style.setProperty('--screen-height', screenHeight );
        }
        else {
            const fixedContent = mainContent.getElementsByClassName('fixed-content')[0] as HTMLElement;
            const scrollContent = mainContent.getElementsByClassName('scroll-content')[0] as HTMLElement;
          
            if(dataLength >= 10 || direction == "up")
            {
                footer.classList.add('invisible');
                document.documentElement.style.setProperty('--top-offset', '0px');
                document.documentElement.style.setProperty('--bottom-offset', '0px');
                document.documentElement.style.setProperty('--screen-height', window.innerHeight + 'px' );
        
            
                fixedContent.style.marginBottom = '0px';
                scrollContent.style.marginBottom = '0px';
            } else if (dataLength < 10) {
                footer.classList.remove('invisible');
                let tabbar = document.getElementsByClassName('tabbar')[0];
                let topCaculatedOffset = tabbar.clientHeight * 2 + 10;
                document.documentElement.style.setProperty('--top-offset', topCaculatedOffset + 'px');
                let bottomCaculatedOffset = footer.offsetHeight;
                document.documentElement.style.setProperty('--bottom-offset', bottomCaculatedOffset + 'px');
            
                let screenHeight = (window.innerHeight - bottomCaculatedOffset - topCaculatedOffset) + 'px';
                document.documentElement.style.setProperty('--screen-height', screenHeight );

                fixedContent.style.marginBottom = footer.offsetHeight + 'px';
                scrollContent.style.marginBottom = footer.offsetHeight + 'px';
            }
        }
      }

    /** Math random can be duplicated => add datetime value */
    generateGUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
            var r = Math.random() + new Date().getTime()  * 16 | 0,
            v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    /**
     * Return item type for bom materrial
     * CCLIORDER-2043
     * @param isParent boolean
     * @param settingId string
     */
    generateItemCategoryForBomProduct(isParent: boolean, settingId: string): string {
        if (isParent === true) {
            switch (settingId) {
                case SettingId.TH:
                    return 'ZTAI'
                case SettingId.SG:
                    return 'ZTAQ'
                default:
                    return ''
            }
        } else {
            switch (settingId) {
                case SettingId.TH:
                    return 'ZTAN'
                case SettingId.SG:
                    return 'ZTAE'
                default:
                    return ''
            }
        }
    }


    getAvailableTimeslots(currentDate: Date, isModal: Boolean) {
        const result: any[] = [];

        result.push({
            code: '',
            label: 'Not an Urgent Order',
        });

        const minutesNow =
            currentDate.getHours() * 60 + currentDate.getMinutes();

        // const cutoffMorning = 9 * 60;    // 09:00 AM
        // const cutoffAfternoon = 15 * 60; // 03:00 PM

        const cutoffMorning = 9 * 60;    // 09:00 AM
        const cutoffAfternoon = 15 * 60; // 03:00 PM

        let targetDate = new Date(currentDate);

        // After 3:00 PM → show tomorrow
        if (minutesNow > cutoffAfternoon) {
            targetDate.setDate(targetDate.getDate() + 1);
        }

        const dateLabel = this.formatDate(targetDate);

        //Tomorrow timeslot AM
        const amSlot = {
            code: UrgentOrderTimeSlotEnum.AM.toString(),
            label: `[${dateLabel}] 8.30AM - 1.00PM`,
        };

        //Tomorrow timeslot PM
        const pmSlot = {
            code: UrgentOrderTimeSlotEnum.PM.toString(),
            label: `[${dateLabel}] 1.01PM - 5.30PM`,
        };

        //Today timeslot PM only
        const tpmSlot = {
            code: UrgentOrderTimeSlotEnum.TPM.toString(),
            label: `[${dateLabel}] 1.01PM - 5.30PM`,
        };

        if (isModal) {
            result.push(amSlot, pmSlot, tpmSlot);
        } else if (minutesNow <= cutoffMorning) {
            result.push(amSlot, pmSlot);
        } else if (minutesNow <= cutoffAfternoon) {
            result.push(tpmSlot);
        } else {
            result.push(amSlot, pmSlot);
        }

        return result;
    }

    formatDate(date: Date): string {
        const dd = String(date.getDate()).padStart(2, '0');
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        return `${dd}/${mm}`;
    }

    isRemoveDKSHLogoForVN(): boolean {
        return window.location.hostname.indexOf(this.config.VnWebURL) !== -1;
    }

    private freightFeeSkus: string[] = ['510030278', '510030279', '510036144'];

    isFreightFeeSku(prd_code: string, settingId: string): boolean {
        return settingId === SettingId.TW && this.freightFeeSkus.includes(prd_code);
    }

    getExpectedFreightFeeSku(salesorg: string, division: string): string | null {
        if (salesorg === 'TW51' && division === 'WF') {
            return '510036144';
        } else if (salesorg === 'TW51') {
            return '510030278';
        } else if (salesorg === 'TW52') {
            return '510030279';
        } else {
            return null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/services/util.service.ts